import { StatusChangeEventApiCaller } from "../../middlewares/StatusChangeEventApiCaller";
import store from "../../store/store";
import { CommonConstants,StatusChangeEventConstants} from "../../constants";
import {showError,getShowFlex } from "../../actions";
//import defaultStatusChangeEventMock from "../../mock/defaultStatusChangeEventMock.json"

export const getStatusChangeEventData = async () => {
      try {
        const response = await StatusChangeEventApiCaller.getStatusChangeEventDatan();
        if(response && response?.statusCode === 200){
         store.dispatch({
          type: StatusChangeEventConstants.GET_STATUS_CHANGE_EVENT_DATA,
          payload: response
        });
        store.dispatch(await getShowFlex());
      }
        else {
          showError(response?.errorMessage);
        }
      } 
      catch (error: any) {
        error && showError(error?.message);
      }
      return {
        type: CommonConstants.NO_CHANGE
      };
};

//Benefit
export const setStatusChangeEventOption = (
   statusChangeBenefitCombinationID: number,
    savedCallback?: (data: any) => void // @TODO - Remove Callback
  ) => {
   
      StatusChangeEventApiCaller.setStatusChangeEventOption(statusChangeBenefitCombinationID)
      .then(async (response) => {
        if (response && response?.statusCode === 200) {

          store.dispatch({
            type: StatusChangeEventConstants.CHANGE_OPTION,
            payload: response
          });

          store.dispatch(await getShowFlex());
          savedCallback && savedCallback(response);
        }
        else {
          showError(response?.errorMessage);
        }
      })
      .catch((error: any) => {
        console.log("error", error);
        showError(error?.message);
        // saveFailedCallback && saveFailedCallback(error);
      });
    return {
      type: CommonConstants.NO_CHANGE
    };
  };

  export const saveStatusChangeEventOption = (
    statusChangeBenefitCombinationID: number,
    isConfirmed:boolean,
     savedCallback?: (data: any) => void, // @TODO - Remove Callback
     failedCallback?: (errorId?: string) => void // @TODO - Remove Callback
   ) => {
    
       StatusChangeEventApiCaller.saveStatusChangeEventOption(statusChangeBenefitCombinationID,isConfirmed)
       .then(async (response) => {
         if (response && response?.statusCode === 200) {
           savedCallback && savedCallback(response);
         }
         else {
          failedCallback && failedCallback(response?.errorMessage);
        }
       })
       .catch((error: any) => {
         console.log("error", error);
         showError(error?.message);

       });
     return {
       type: CommonConstants.NO_CHANGE
     };
   };

 
